/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface QuantityButtonProps {
  handleIncrease: (event: any) => void;
  handleDecrease: (event: any) => void;
  name: number;
  className: string;
}

/**
 * Reusable React component - QuantityButton.
 *
 * @namespace QuantityButton
 */
class QuantityButton extends React.Component<QuantityButtonProps> {
  constructor(props: QuantityButtonProps) {
    super(props);
    this.state = {
      submitted: false,
    };
  }

  /**
   * This method is used for handle button decrease click
   * @param {any} event
   *
   */
  handleDecrease = (event: any) => {
    if (this.props.handleDecrease) {
      this.props.handleDecrease(event);
    }
  };
  handleDecreaseKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleDecrease(event)
    }
  }

  /**
   * This method is used for handle button increase click
   * @param {any} event
   *
   */
  handleIncrease = (event: any) => {
    if (this.props.handleIncrease) {
      this.props.handleIncrease(event);
    }
  };
  handleIncreaseKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleIncrease(event)
    }
  }
  render() {
    const { name, className } = this.props;
    return (
      <div tabIndex={0} className="btn-area quantity-btn-area">
        <div tabIndex={0} role="button" aria-label="Button for Decrease product Quantity" className="decrease-btn" onClick={this.handleDecrease} onKeyPress={this.handleDecreaseKeyPress}>
          -
        </div>
        <button tabIndex={-1} aria-hidden="true" className={className || "app-btn"}>{name}</button>
        <div tabIndex={0} role="button" aria-label="Increase product Quantity" className="increase-btn" onClick={this.handleIncrease} onKeyPress={this.handleIncreaseKeyPress}>
          +
        </div>
      </div>
    );
  }
}

export default QuantityButton;
